import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export var ViewConverter = /*#__PURE__*/function () {
  function ViewConverter(viewRID) {
    _classCallCheck(this, ViewConverter);
    this.viewRID = viewRID;
    _defineProperty(this, "zones", []);
    _defineProperty(this, "blocks", []);
    _defineProperty(this, "countersByType", {});
  }
  return _createClass(ViewConverter, [{
    key: "convertZones",
    value: function convertZones(createZones) {
      if (!createZones) {
        return [];
      }
      var zonesInNode = [];
      var _iterator = _createForOfIteratorHelper(createZones),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _zoneToCreate$zoneRID, _zoneToCreate$zonePar;
          var zoneToCreate = _step.value;
          var zoneRID = (_zoneToCreate$zoneRID = zoneToCreate.zoneRID) !== null && _zoneToCreate$zoneRID !== void 0 ? _zoneToCreate$zoneRID : this.createNextRid(this.viewRID, 'zone');
          var zone = _objectSpread({
            zoneRID: zoneRID,
            zoneType: zoneToCreate.zoneType,
            zoneParameters: (_zoneToCreate$zonePar = zoneToCreate.zoneParameters) !== null && _zoneToCreate$zonePar !== void 0 ? _zoneToCreate$zonePar : {}
          }, mapNodeProperties(zoneToCreate));
          this.zones.push(zone);
          zonesInNode.push(zoneRID);
          this.convertBlocks(zoneRID, zoneToCreate.blocks || []);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return zonesInNode;
    }
  }, {
    key: "convertBlocks",
    value: function convertBlocks(parentZoneRID, createBlocks) {
      if (!createBlocks) {
        return [];
      }
      var _iterator2 = _createForOfIteratorHelper(createBlocks),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _blockToCreate$blockR, _blockToCreate$blockP;
          var blockToCreate = _step2.value;
          var blockRID = (_blockToCreate$blockR = blockToCreate.blockRID) !== null && _blockToCreate$blockR !== void 0 ? _blockToCreate$blockR : this.createNextRid(this.viewRID, 'block');
          var block = _objectSpread({
            blockRID: blockRID,
            blockName: blockToCreate.blockName,
            blockParameters: (_blockToCreate$blockP = blockToCreate.blockParameters) !== null && _blockToCreate$blockP !== void 0 ? _blockToCreate$blockP : {},
            parentZoneRID: parentZoneRID,
            zoneRIDs: this.convertZones(blockToCreate.zones || [])
          }, mapNodeProperties(blockToCreate));
          this.blocks.push(block);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "createNextRid",
    value: function createNextRid(container, type) {
      var ridCounter = this.getAndIncrementCounter(type);
      var nextRid = "".concat(container, "/").concat(type, "-").concat(ridCounter);
      return nextRid;
    }
  }, {
    key: "getAndIncrementCounter",
    value: function getAndIncrementCounter(type) {
      var _this$countersByType$;
      this.countersByType[type] = (_this$countersByType$ = this.countersByType[type]) !== null && _this$countersByType$ !== void 0 ? _this$countersByType$ : 0;
      var counter = this.countersByType[type];
      this.countersByType[type]++;
      return counter;
    }
  }], [{
    key: "convertView",
    value: function convertView(input) {
      var _input$view$rid, _input$view$container, _input$view$name;
      var converter = new ViewConverter((_input$view$rid = input.view.rid) !== null && _input$view$rid !== void 0 ? _input$view$rid : "".concat((_input$view$container = input.view.containerRID) !== null && _input$view$container !== void 0 ? _input$view$container : 'sharefile:account-*', "/view-*"));
      if (input.layout.block) {
        converter.convertBlocks('root', [input.layout.block]);
      }
      return {
        rid: converter.viewRID,
        name: (_input$view$name = input.view.name) !== null && _input$view$name !== void 0 ? _input$view$name : '',
        rootBlockRID: converter.blocks.find(function (x) {
          return x.parentZoneRID === 'root';
        }).blockRID,
        blocks: converter.blocks,
        zones: converter.zones
      };
    }
  }, {
    key: "convertBlock",
    value: function convertBlock(viewRID, parentZoneRID, input) {
      var converter = new ViewConverter(viewRID);
      converter.convertBlocks(parentZoneRID, [input]);
      return {
        blocks: converter.blocks,
        zones: converter.zones
      };
    }
  }, {
    key: "convertZone",
    value: function convertZone(viewRID, input) {
      var converter = new ViewConverter(viewRID);
      converter.convertZones([input]);
      return {
        blocks: converter.blocks,
        zones: converter.zones
      };
    }
  }]);
}();
function mapNodeProperties(_ref) {
  var condition = _ref.condition,
    foreach = _ref.foreach,
    as = _ref.as;
  return {
    condition: condition,
    foreach: foreach,
    as: as
  };
}